import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./AccessDenied.module.css";
import { Link } from "react-router-dom";
const AccessDenied = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const errorCode = params.get("errorCode");
  const errorMessage = params.get("errorMessage");
  const errorDescription = params.get("errorDescription");
  return (
    <div>
      <div className={styles["page-wrap"]}>
        <div className={styles["page-not-found"]}>
          <img src="https://res.cloudinary.com/razeshzone/image/upload/v1588316204/house-key_yrqvxv.svg" className={styles["img-key"]} alt="" />
          <h1 className={styles["text-xl"]}>
            <span>{errorCode.split()[0]}</span>
            <span>{errorCode.split()[1]}</span>
            <span className={styles.broken}>{errorCode.split()[2]}</span>
          </h1>
          <h4 className={styles["text-md"]}>{errorMessage}</h4>
          <h4 className={`${styles["text-sm"]} ${styles["text-sm-btm"]}`}>
            {errorDescription} <Link to='/contact' className="btn btn-link errorlink">Contact us</Link>for assistance
           
           
          </h4>
          <h4 className={`${styles["text-sm"]} ${styles["text-sm-btm"]}`}>
             Go back to <Link to='..' className="btn btn-link errorlink">Previous Page</Link>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
